import React from "react";
import axios from "axios";
import qualitySelector from "videojs-hls-quality-selector";
import qualityLevels from "videojs-contrib-quality-levels";

import "url-search-params-polyfill"; // For IE11 & searchParams
// for Promises in IE11 I use the 'es6-promise.auto.min' library
export default class Embeds extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      websocketEndpoint: props.ws, // production(staging) host must be 'wss://xxx.channel.or.jp/ws'.
      domain: props.domain,
      eventUUID: props.uuid,
      token: props.token,
      cookie_lifetime_in_hours: props.cookie_lifetime,
      state: "none",
      liveSurvey: props.live_event.data.Survey,
      liveChannel: props.live_event.data.Channel,
      liveEvent: props.live_event.data,
      isPlayerInitialized: false,
      styleQuestionnaire: "",
      sumAnswer_1: 0,
      sumAnswer_2: 0,
      sumAnswer_3: 0,
      sumAnswer_4: 0,
      sumAnswer_5: 0,
      sumAnswer_6: 0,
      ratio_1_percent: 0,
      ratio_2_percent: 0,
      ratio_3_percent: 0,
      ratio_4_percent: 0,
      ratio_5_percent: 0,
      ratio_6_percent: 0,
      styleRatio: "",
      isResponseSent: false,
      message: "",
      userChoice: 0,
      classBtn1: "movieQuestionnaire__button",
      classBtn2: "movieQuestionnaire__button",
      classBtn3: "movieQuestionnaire__button",
      classBtn4: "movieQuestionnaire__button",
      classBtn5: "movieQuestionnaire__button",
      classBtn6: "movieQuestionnaire__button",
      originalSurveyUUID: props.live_event.data.Survey.UUID,
      isPublic: !props.live_event.data.Privacy,
      privateMsg: "この動画は非公開です。Sorry, this video is private.",
      isMuted: true,
      isAutoplay: true,
      isLiveui: false,
      isPauseDisabled: false,
      clientUUID: "",
      paramUUID: "",
      paramStart: "",
      isFullscreen: true,
      isWithCred: props.credentials,
      analyticsDomain: props.domain + "/ex/live_analytics",
      beaconDelayMS: props.analytics_beacon_delay,
      videoIsPlaying: false,
      uuidCookieLifetime: props.uuidCookieLifetime,
      isButtonDisabled: false,
      player: "",
      playerType: props.live_event.data.Player_type,
      padding: {},
      isSearchParamsReady: false,
      sleepDuration: 300,
      pollingDuration: 60,
      isTracking: true
    };
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.putSurveyStat = this.putSurveyStat.bind(this);
    this.calculatePercentage = this.calculatePercentage.bind(this);
    this.showRatio = this.showRatio.bind(this);
    this.setCookie = this.setCookie.bind(this);
    this.showEnquete = this.showEnquete.bind(this);
    this.liveEvent = this.liveEvent.bind(this);
    this.checkWssMsg = this.checkWssMsg.bind(this);
    this.getLatestStats = this.getLatestStats.bind(this);
    this.sendBeaconToAnalytics = this.sendBeaconToAnalytics.bind(this);
    this.sendPlayEvent = this.sendPlayEvent.bind(this);
    this.generateUuid = this.generateUuid.bind(this);
    this.checkUUID = this.checkUUID.bind(this);
    this.readCookie = this.readCookie.bind(this);
    this.displayUserAnswer = this.displayUserAnswer.bind(this);
    this.showResults = this.showResults.bind(this);
    this.isAndroid = this.isAndroid.bind(this);
    this.isIphone = this.isIphone.bind(this);
    this.createWS = this.createWS.bind(this);
    this.createServerSideEvents = this.createServerSideEvents.bind(this);
    this.eventMessage = this.eventMessage.bind(this);
    this.getSearchParams = this.getSearchParams.bind(this);
    this.checkingTimerSleep = this.checkingTimerSleep.bind(this);
    this.changePlayerType = this.changePlayerType.bind(this);
  }
  render() {
    return this.state.isPublic ? (
      this.state.playerType == "player" ? (
        <div className="wrapper">
          <div>
            <video
              id="content_video"
              className="video-js vjs-default-skin vjs-big-play-centered"
              preload="yes"
              style={this.state.padding}
              playsInline
              controls
            ></video>
          </div>
          <div
            id="movieQuestionnaire"
            className={`movieQuestionnaire__bg${this.state.styleQuestionnaire}`}
          >
            <div className="movieQuestionnaire__bg2">
              <div className="movieQuestionnaire__wrap">
                <p className="movieQuestionnaire__thanks--answer">
                  {this.state.message}
                </p>
                <p className="movieQuestionnaire__question">
                  {this.state.liveSurvey.Question}
                </p>
                <div className="movieQuestionnaire__buttons">
                  <button
                    className={this.state.classBtn1}
                    id="1"
                    onClick={this.handleButtonClick}
                    disabled={this.state.isButtonDisabled}
                  >
                    <span className="movieQuestionnaire__text" id="1">
                      {this.state.liveSurvey.Answer_1}
                    </span>
                    <span
                      className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                      id="1"
                    >
                      <span>{this.state.ratio_1_percent}%</span>
                    </span>
                  </button>
                  <button
                    className={this.state.classBtn2}
                    id="2"
                    onClick={this.handleButtonClick}
                    disabled={this.state.isButtonDisabled}
                  >
                    <span className="movieQuestionnaire__text" id="2">
                      {this.state.liveSurvey.Answer_2}
                    </span>
                    <span
                      className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                      id="2"
                    >
                      <span>{this.state.ratio_2_percent}%</span>
                    </span>
                  </button>
                  {this.state.liveSurvey.Answer_3 ? (
                    <button
                      className={this.state.classBtn3}
                      id="3"
                      onClick={this.handleButtonClick}
                      disabled={this.state.isButtonDisabled}
                    >
                      <span className="movieQuestionnaire__text" id="3">
                        {this.state.liveSurvey.Answer_3}
                      </span>
                      <span
                        className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                        id="3"
                      >
                        <span>{this.state.ratio_3_percent}%</span>
                      </span>
                    </button>
                  ) : null}
                  {this.state.liveSurvey.Answer_4 ? (
                    <button
                      className={this.state.classBtn4}
                      id="4"
                      onClick={this.handleButtonClick}
                      disabled={this.state.isButtonDisabled}
                    >
                      <span className="movieQuestionnaire__text" id="4">
                        {this.state.liveSurvey.Answer_4}
                      </span>
                      <span
                        className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                        id="4"
                      >
                        <span>{this.state.ratio_4_percent}%</span>
                      </span>
                    </button>
                  ) : null}
                  {this.state.liveSurvey.Answer_5 ? (
                    <button
                      className={this.state.classBtn5}
                      id="5"
                      onClick={this.handleButtonClick}
                      disabled={this.state.isButtonDisabled}
                    >
                      <span className="movieQuestionnaire__text" id="5">
                        {this.state.liveSurvey.Answer_5}
                      </span>
                      <span
                        className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                        id="5"
                      >
                        <span>{this.state.ratio_5_percent}%</span>
                      </span>
                    </button>
                  ) : null}
                  {this.state.liveSurvey.Answer_6 ? (
                    <button
                      className={this.state.classBtn6}
                      id="6"
                      onClick={this.handleButtonClick}
                      disabled={this.state.isButtonDisabled}
                    >
                      <span className="movieQuestionnaire__text" id="6">
                        {this.state.liveSurvey.Answer_6}
                      </span>
                      <span
                        className={`movieQuestionnaire__ratio${this.state.styleRatio}`}
                        id="6"
                      >
                        <span>{this.state.ratio_6_percent}%</span>
                      </span>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <img
          style={{ width: "100%", height: "auto" }}
          src={this.state.liveEvent.Poster_url}
        ></img>
      )
    ) : (
      <h1 className="title permission-message">
        Sorry, this video is private.
        <br />
        この動画は非公開です。
      </h1>
    );
  }

  componentDidMount() {
    // Sending Beacon to Real Time Analytics every n minutes
    // Call the live analytics API every n minutes
    this.interval = setInterval(
      () => this.sendBeaconToAnalytics(),
      this.state.beaconDelayMS
    );

    // Client UUID
    this.checkUUID();

    this.getSearchParams();

    window.addEventListener("message", this.eventMessage);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSearchParamsReady !== prevState.isSearchParamsReady) {
      this.liveSurvey();
      this.setStats();

      // If OS (PC) is sleepd for n seconds, Window is reloaded.
      const sleepDuration = this.state.sleepDuration > 0 ? this.state.sleepDuration : 300;
      this.checkingTimerSleep(sleepDuration)

      // Fetch EventAPI by polling every n minutes
      // Avoid risks for websocket failure
      const pollingTimeSeconds = this.state.pollingDuration > 0 ? this.state.pollingDuration : 60;
      const pollingTime = pollingTimeSeconds * 1000;
      this.pollingInterval = setInterval(() => {
        this.liveEvent();
      }, pollingTime);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.pollingInterval);
  }

  checkingTimerSleep(s = 300) {
    let start = Date.now();
    const timer = 5000
    const timeoutLoop = () => {
      const millis = Date.now() - start;
      const seconds = Math.floor(millis / 1000)
      start = Date.now();
      
      if(seconds > s) {
        console.log(`Sleeping Duration : ${seconds}s`);
        console.log("Long Sleep!");
        window.location.reload();
      }
      setTimeout(timeoutLoop, timer)
    }
    timeoutLoop()
  }

  getSearchParams(e) {
    let searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has("autoplay")) {
      var valueString = searchParams.get("autoplay");
      var value = true;
      if (valueString == "false") {
        value = false;
      }
      this.setState({ isAutoplay: value, isMuted: value });
    }

    if (searchParams.has("liveui")) {
      var value = searchParams.get("liveui");
      if (value == "true" || value == "1") {
        this.setState({ isLiveui: true });
      }
    }

    // disable pause action and hidden button.
    if (searchParams.has("disablepb")) {
      var value = searchParams.get("disablepb");
      if (value == "true" || value == "1") {
        this.setState({ isPauseDisabled: true });
      }
    }

    if (searchParams.has("uuid")) {
      var value = searchParams.get("uuid");
      if (value) {
        this.setState({ paramUUID: value });
      }
    }

    if (searchParams.has("start")) {
      var value = searchParams.get("start");
      if (value) {
        // Ex value: yyyy-mm-ddThh:mm:ss+09:00
        var decodedValue = decodeURI(value).replace(/\s/g, "+");
        this.setState({ paramStart: decodedValue });
      }
    }

    // Disable fullscureen for PC and Mobile
    if (searchParams.has("fullscreen")) {
      var value = searchParams.get("fullscreen");
      if (value == "false" || value == "0") {
        this.setState({ isFullscreen: false });
      }
    }

    // Disable fullscreen for PC
    if (searchParams.has("pcfullscreen")) {
      var value = searchParams.get("pcfullscreen");
      if (value == "false" || value == "0") {
        if (this.isAndroid() || this.isIphone()) {
          //console.log("isMobile");
          this.setState({ isFullscreen: true });
        } else if (value == "false") {
          this.setState({ isFullscreen: false });
        }
      }
    }

    // Padding-top set 0 to fill in iframe.
    if (searchParams.has("padding")) {
      var value = searchParams.get("padding");
      if (value == "false" || value == "0") {
        this.setState({ padding: { paddingTop: 0 } });
      }
    }

    // XF Signed Cookie Support option. wild card header(*) option doesn't support. Check your CORS Option when applying this.
    if (searchParams.has("withcred")) {
      var value = searchParams.get("withcred");
      if (value == "true" || value == 1) {
        this.setState({ isWithCred: true });
      }else {
        this.setState({ isWithCred: false });
      }
    }

    if (searchParams.has("sleep")) {
      const value = searchParams.get("sleep");
      if(!isNaN(value)){
        const numValue = Number(value)
        this.setState({sleepDuration: numValue})
      }
    }

    if (searchParams.has("polling")) {
      const value = searchParams.get("polling");
      if(!isNaN(value)){
        const numValue = Number(value)
        this.setState({pollingDuration: numValue})
      }
    }

    if (searchParams.has("tracking")) {
      const valueString = searchParams.get("tracking");

      if (valueString === "false") {
        this.setState({isTracking: false})
      } else {
        this.setState({isTracking: true})
      }
    }

    this.setState({ isSearchParamsReady: true });
  }

  eventMessage(e) {
    // console.log("[eventMessage] origin:" + e.origin)
    // console.log("[eventMessage] data:" + e.data)

    // Check the origin if needed.
    if (e.origin.indexOf("xxx.jp") == -1) {
      // console.log(e.origin + " Not allowed");
      // return;
    }

    var event = "";
    var value = "";
    try {
      event = JSON.parse(e.data).playerEvent;
      value = JSON.parse(e.data).playerEventValue;
    } catch (e) {
      return false;
    }

    switch (event) {
      case "mute":
        this.state.player.muted(true);
        break;
      case "unmute":
        this.state.player.muted(false);
        break;
      case "pause":
        this.state.player.pause();
        break;
      case "play":
        this.state.player.play();
        break;
      case "volume":
        // value should be 0(off) - 1.0(max), 0.5 is half way.
        this.state.player.volume(value);
        break;
      default:
        console.log("[eventMessage] The event is NOT supported.");
        break;
    }
  }

  initPlayer() {
    //INIT, called once
    let options = {
      autoplay: this.state.isAutoplay,
      fluid: true,
      poster: this.state.liveEvent.Poster_url,
      liveui: this.state.isLiveui,
      controlBar: {
        fullscreenToggle: this.state.isFullscreen,
        playToggle: !this.state.isPauseDisabled,
        pictureInPictureToggle: false,
      },
      html5: {
        hls: { withCredentials: this.state.isWithCred },
      },
    };

    if (this.isAndroid()) {
      // On Android,  VideoJS does not recover from 403 error after switching from main stream to backup stream. We force Android Chrome to use contrib-hls.
      videojs.options.hls.overrideNative = true;
      videojs.options.html5.nativeAudioTracks = false;
      videojs.options.html5.nativeVideoTracks = false;
    }

    // Quality Selector Init
    videojs.registerPlugin("hlsQualitySelector", qualitySelector);
    videojs.registerPlugin("qualityLevels", qualityLevels);

    this.player = videojs("content_video", options, () => {
      this.player.muted(this.state.isMuted);

      if (this.state.isLiveui && this.state.paramStart != "") {
        // MediaPackage Only is Used for DVR time-shifted viewing to set start parameter.
        this.player.src([
          {
            type: "application/x-mpegURL",
            src:
              this.state.liveChannel.Custom_live_url +
              "?start=" +
              this.state.paramStart,
          },
        ]);
      } else {
        this.player.src([
          {
            type: "application/x-mpegURL",
            src: this.state.liveChannel.Custom_live_url,
          },
        ]);
      }

      try {
        this.player.hlsQualitySelector({ displayCurrentQuality: true });
      } catch (e) {
        console.log(e);
      }
      this.setState({ isPlayerInitialized: true });

      // Disable pause/play action on player if disablepb param is set.
      if (this.state.isPauseDisabled) {
        $(".vjs-tech").css("pointer-events", "none");
      }
    });

    // Debug logs  : some html5 media events
    // this.player.on(['ended','error','pause','abort','emptied','interruptbegin', 'interruptend','stalled', 'suspend','waiting'], (e) => {
    //     console.log("Media events: " + e.type);
    // });

    this.player.on(["ended", "error", "pause"], e => {
      this.setState({ videoIsPlaying: false });
      //console.log("Playing : false " + e.type);
    });

    this.player.on(["playing", "play"], e => {
      this.setState({ videoIsPlaying: true });
      //console.log("Playing : true " + e.type);
    });

    //Sending the first beacon without waiting for n minutes
    this.player.one(["playing"], e => {
      this.sendBeaconToAnalytics();
      this.sendPlayEvent();
    });

    // Used for controling player API by postMessage.
    this.setState({ player: this.player });
  }

  liveEvent() {
    /*
        Sequence order:
        liveEvent() -> liveSurvey() -> initPlayer()
    */
    var parent = this;
    axios({
      url:
        parent.state.domain +
        "/ex/events/" +
        parent.state.eventUUID +
        "?embed=channel,survey",
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + parent.state.token,
        "Content-Type": "application/json",
        Pragma: "no-cache",
      },
    })
      .then(function (res) {
        // Why the defined parent is needed?: https://forum.freecodecamp.org/t/cant-get-the-data-into-state/52205/2
        parent.setState(
          {
            liveEvent: res.data.data,
            liveChannel: res.data.data.Channel,
            liveSurvey: res.data.data.Survey,
            originalSurveyUUID: res.data.data.Survey.UUID,
            //playerType: res.data.data.Player_type,
          },
          () => {
            parent.liveSurvey();
            parent.setStats();
            parent.changePlayerType(res.data.data.Player_type)
          }
        );
      })
      .catch(error => {
        console.log("Error: " + error);
      });
  }

  liveSurvey() {
    var parent = this;
    const surveyUUID = this.state.liveSurvey.UUID;
    axios({
      url: this.state.domain + "/ex/surveys/" + surveyUUID + "?embed=stats",
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + this.state.token,
        "Content-Type": "application/json",
        Pragma: "no-cache",
      },
    })
      .then(function (res) {
        parent.displayUserAnswer();
        parent.setState({ liveSurvey: res.data.data }, () => {
          if (!parent.state.liveEvent.Privacy) {
            parent.setState({ isPublic: true });
            // We initialized the player only once
            if (!parent.state.isPlayerInitialized) {
              if (parent.state.playerType == "player") {
                parent.initPlayer();
              }
            }
            // Displaying Enquete accorindg Survey state
            var surveyState = parent.state.liveSurvey.State;
            if (surveyState == "submit") {
              parent.showEnquete();
            } else if (surveyState == "answer") {
              parent.showRatio();
            }
          } else {
            parent.setState({ isPublic: false });
          }
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  createWS() {
    const ws = new WebSocket(this.state.websocketEndpoint);
    var that = this;

    ws.onmessage = e => {
      var data = JSON.parse(e.data);
      var state = data.state;
      var surveyUUID = data.suid;
      var involvedEventUUID = data.evuuid;
      var isEventMatched = false;
      var parent = this; //To reduce API calls
      if (this.state.liveEvent.UUID == involvedEventUUID) {
        isEventMatched = true;
      }

      // Check if the Event's survey has changed
      var uddateSurveyUUID = () => {
        var promise = new Promise(function (resolve, reject) {
          if (isEventMatched) {
            parent.liveEvent();
          }
          if (parent.state.originalSurveyUUID != surveyUUID) {
            // SurveyUUID has changed
            var previousChoosenAnswerID = parent.state.userChoice;
            if (previousChoosenAnswerID != 0) {
              // Reset style of the choosen answer button
              parent.setState({
                [`classBtn${previousChoosenAnswerID}`]: "movieQuestionnaire__button",
                isResponseSent: false,
              });
            }
          }
        });
        return promise;
      };
      uddateSurveyUUID()
        .then(parent.checkWssMsg(surveyUUID, state, involvedEventUUID))
        .catch(error => {
          console.log(error);
        });
    };

    ws.onerror = e => this.setState({ error: "WebSocket error" });

    ws.onopen = e => {
      // console.log("WSS connection opened");
      //Subscribe to the Topic : init
      var data = { action: "subscribe", topic: "survey" };
      ws.send(JSON.stringify(data));
    };

    ws.onclose = e => {
      // console.log("WS connection closed"); // TODO remove logs for production
      setTimeout(function () {
        that.createWS();
      }, 5000);
    };

    //PlayerType update
    const ws2 = new WebSocket(this.state.websocketEndpoint);
    ws2.onmessage = e => {
      var data = JSON.parse(e.data);

      if (data.evuuid == this.state.eventUUID) {
        this.changePlayerType(data.playerType)
      }
    };

    ws2.onerror = e => this.setState({ error: "WebSocket error" });

    ws2.onopen = e => {
      var dataPlayer = { action: "subscribe", topic: "player" };
      ws2.send(JSON.stringify(dataPlayer));
    };

    // NB handle by ws , not necessary for ws2
    // ws2.onclose = e => {
    //     // console.log("WS connection closed"); // TODO remove logs for production
    //     setTimeout(function(){
    //         that.createWS()
    //     }, 5000);
    // }
  }

  createServerSideEvents() {
    const self = this;
    const evtSource = new EventSource(this.props.live_scheduler);

    evtSource.onopen = function() {
      console.log("Connection to server opened.");
    }

    evtSource.onmessage = function(e) {
      const data = JSON.parse(e.data);
      if (data.eventUUID === self.state.eventUUID && data.type === "update") {
        self.changePlayerType(data.playerType)
      }
    }

    evtSource.onerror = function(e) {
      console.log(e)
    };
  }

  changePlayerType(type) {
    if (this.state.playerType !== type) {
      var isPlayerInitialized = false;
      try {
        let oldPlayer = document.getElementById("content_video_html5_api");
        if (oldPlayer){
          videojs(oldPlayer).dispose();
        }
      } catch (e) {
        console.log(e);
      }

      this.setState(
        {
          playerType: type,
          isPlayerInitialized: isPlayerInitialized,
        },
        () => {
          this.liveEvent();
        }
      );
    }

    if (type === "poster") {
      this.setState({ videoIsPlaying: false });
    }
  }

  componentWillMount() {
    this.createWS();
    if(this.props.live_scheduler){
      this.createServerSideEvents();
    }
  }

  checkWssMsg(surveyUUID, state, involvedEventUUID) {
    if (
      this.state.liveSurvey.UUID == surveyUUID &&
      this.state.liveEvent.UUID == involvedEventUUID
    ) {
      this.setState({ state: state });
      switch (state) {
        case "submit":
          this.showEnquete();
          break;

        case "none":
          this.setState({
            styleRatio: "",
            styleQuestionnaire: "",
            isButtonDisabled: false,
          });
          break;

        case "answer":
          this.showResults();
          break;

        case "finished":
          this.reset();
          break;

        default:
          console.log("unexpected state:" + state);
          this.setState({ state: "error", isButtonDisabled: true });
          break;
      }
    }
  }

  putSurveyStat(id) {
    var parent = this;
    const uuid = this.state.liveSurvey.Survey_stat.UUID;
    axios({
      url: this.state.domain + "/ex/survey_stats/" + uuid + "/answers/" + id,
      method: "PUT",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + this.state.token,
        "Content-Type": "application/json",
        Pragma: "no-cache",
      },
    })
      .then(function (res) {
        console.log("Live Survey: " + parent.state.liveSurvey);
        var cname = parent.state.liveSurvey.UUID;
        var cvalue = "voted";
        var lifetimeInHours = parent.state.cookie_lifetime_in_hours;
        parent.setCookie(cname, cvalue, lifetimeInHours);
      })
      .catch(error => {
        console.log("Error: " + error);
      });
  }

  handleButtonClick(e) {
    e.preventDefault();
    var id = e.target.id;

    if (!this.state.isResponseSent) {
      this.putSurveyStat(id);

      //Change style of choosen answer button
      this.setState(
        {
          isButtonDisabled: true,
          userChoice: id,
          isResponseSent: true,
          message: "ご協力ありがとうございました！",
          [`classBtn${id}`]: "movieQuestionnaire__button--active",
        },
        () => {
          // Saving the user choice in the cookie
          var cname = this.state.liveSurvey.UUID + "_user_choice";
          var cvalue = this.state.userChoice;
          var lifetimeInHours = this.state.cookie_lifetime_in_hours;
          this.setCookie(cname, cvalue, lifetimeInHours);
        }
      );
    } else {
      console.log("You already answered that questionnaire.");
    }
  }

  getLatestStats() {
    console.log("Get latest stats");
    //One response only by questionnaire by user
    var parent = this;
    const surveyUUID = this.state.liveSurvey.UUID;
    //Get the latest stats
    axios({
      method: "GET",
      url: this.state.domain + "/ex/surveys/" + surveyUUID + "?embed=stats",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + this.state.token,
        "Content-Type": "application/json",
        Pragma: "no-cache",
      },
    }).then(function (res) {
      parent.setState({ liveSurvey: res.data.data }, () => {
        var updateStats = () => {
          var promise = new Promise(function (resolve, reject) {
            parent.setStats();
          });
          return promise;
        };
        updateStats()
          .then(parent.showRatio())
          .catch(error => {
            console.log(error);
          });
      });
    });
  }

  setStats() {
    var sumList = this.state.liveSurvey.Survey_stat;
    this.setState(
      {
        sumAnswer_1: sumList.Answer_1_count,
        sumAnswer_2: sumList.Answer_2_count,
        sumAnswer_3: sumList.Answer_3_count,
        sumAnswer_4: sumList.Answer_4_count,
        sumAnswer_5: sumList.Answer_5_count,
        sumAnswer_6: sumList.Answer_6_count,
      },
      () => {
        this.calculatePercentage();
      }
    );
  }

  calculatePercentage() {
    var totalVote =
      this.state.sumAnswer_1 +
      this.state.sumAnswer_2 +
      this.state.sumAnswer_3 +
      this.state.sumAnswer_4 +
      this.state.sumAnswer_5 +
      this.state.sumAnswer_6;
    var ratio_1 =
      this.state.sumAnswer_1 == 0
        ? 0
        : ((this.state.sumAnswer_1 * 100) / totalVote).toFixed(0);
    var ratio_2 =
      this.state.sumAnswer_2 == 0
        ? 0
        : ((this.state.sumAnswer_2 * 100) / totalVote).toFixed(0);
    var ratio_3 =
      this.state.sumAnswer_3 == 0
        ? 0
        : ((this.state.sumAnswer_3 * 100) / totalVote).toFixed(0);
    var ratio_4 =
      this.state.sumAnswer_4 == 0
        ? 0
        : ((this.state.sumAnswer_4 * 100) / totalVote).toFixed(0);
    var ratio_5 =
      this.state.sumAnswer_5 == 0
        ? 0
        : ((this.state.sumAnswer_5 * 100) / totalVote).toFixed(0);
    var ratio_6 =
      this.state.sumAnswer_6 == 0
        ? 0
        : ((this.state.sumAnswer_6 * 100) / totalVote).toFixed(0);

    this.setState({
      ratio_1_percent: ratio_1,
      ratio_2_percent: ratio_2,
      ratio_3_percent: ratio_3,
      ratio_4_percent: ratio_4,
      ratio_5_percent: ratio_5,
      ratio_6_percent: ratio_6,
    });
  }

  reset() {
    var id = this.state.userChoice;
    console.log("reset btn ID: " + id);
    this.setState(
      {
        [`classBtn${id}`]: "movieQuestionnaire__button",
      },
      () => {
        this.setState({
          styleQuestionnaire: "",
          styleRatio: "",
          isResponseSent: false,
          message: "",
          userChoice: 0,
          isButtonDisabled: false,
        });
      }
    );
  }

  showQuestionnaire() {
    var previousChoosenAnswerID = this.state.userChoice;
    this.setState({
      [`classBtn${previousChoosenAnswerID}`]: "movieQuestionnaire__button",
      isResponseSent: false,
      message: "",
      styleQuestionnaire: "--active",
      styleRatio: "",
      isButtonDisabled: false,
    });
  }

  showRatio() {
    var id = this.state.userChoice;
    this.setState({
      [`classBtn${id}`]: "movieQuestionnaire__button--active",
      styleQuestionnaire: "--active",
      styleRatio: this.state.liveSurvey.State == "submit" ? "" : "--active",
      message: "ご協力ありがとうございました！",
    });
  }

  setCookie(cname, cvalue, lifetimeInHours) {
    try {
      var d = new Date();
      // cookie lifetime needs to be converted to milliseconds
      d.setTime(d.getTime() + lifetimeInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    } catch (e) {
      console.log("Error cannot set the cookie");
      console.log(e);
    }
  }
  readCookie(key) {
    //Returns null if the cookie name is not defined.
    var cookieValue = null;
    cookieValue = (document.cookie.match("(^|; )" + key + "=([^;]*)") || 0)[2];
    return typeof cookieValue == "undefined" ? null : cookieValue;
  }

  displayUserAnswer() {
    var userChoiceCookie = this.readCookie(
      this.state.liveSurvey.UUID + "_user_choice"
    );
    this.setState({
      isButtonDisabled: true, //(userChoiceCookie !=null),
      userChoice:
        userChoiceCookie != null ? userChoiceCookie : this.state.userChoice,
      message: "ご協力ありがとうございました！",
      [`classBtn${userChoiceCookie}`]: "movieQuestionnaire__button--active",
    });
  }

  showEnquete() {
    var cookieValue = this.readCookie(this.state.liveSurvey.UUID); //(document.cookie.match('(^|; )' + this.state.liveSurvey.UUID + '=([^;]*)') || 0)[2];
    if (cookieValue != "voted") {
      this.showQuestionnaire();
    } else {
      console.log("You already voted for that survey");
      this.showResults();
    }
  }

  checkUUID() {
    var cookieValue = (document.cookie.match(
      "(^|; )" + this.state.eventUUID + "=([^;]*)"
    ) || 0)[2];
    var isPatternOk = /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/.test(
      cookieValue
    );
    if (!isPatternOk) {
      // Create a new UUID
      // console.log("Generating a new UUID");
      let clientUUID = this.generateUuid();
      this.setState({ clientUUID: clientUUID });
      // Saving the UUID in a cookie
      this.setCookie(
        this.state.eventUUID,
        clientUUID,
        this.state.uuidCookieLifetime
      );
    } else {
      // console.log("Using existing UUID");
      this.setState({ clientUUID: cookieValue });
    }
  }

  sendBeaconToAnalytics() {
    // NB The beacon is sent if the video is playing and tracking parameter is true
    if (this.state.videoIsPlaying && this.state.isTracking) {
      let uuid =
      this.state.paramUUID !== "" ? this.state.paramUUID : this.state.clientUUID;
      
      var URL =
        this.state.analyticsDomain +
        "/" +
        this.state.eventUUID +
        "?uuid=" +
        uuid;
      //console.log("Beacon...")
      axios({
        method: "POST",
        url: URL,
        timeout: 3000,
        headers: {
          Authorization: "Bearer " + this.state.token,
          "Content-Type": "application/json",
        },
      })
        .then(res => {
          // console.log("Beacon sent");
        })
        .catch(error => {
          // console.log("Beacon not sent");
          console.log("Error: " + error);
        });
    }
  }

  sendPlayEvent() {
    if(this.state.isTracking) {
      var uuid =
      this.state.paramUUID !== "" ? this.state.paramUUID : this.state.clientUUID;
    var URL = this.props.domain + "/ex/play_event";
    axios({
      method: "POST",
      url: URL,
      timeout: 3000,
      headers: {
        Authorization: "Bearer " + this.state.token,
        "Content-Type": "application/json",
      },
      data: {
        UUID: uuid,
        EventUUID: this.state.eventUUID,
      },
    })
      .then(res => {
        // console.log("play event sent");
      })
      .catch(error => {
        // console.log("Beacon not sent");
        console.log("Play Event Error: " + error);
      });
    }
  }

  showResults() {
    this.getLatestStats();
    this.displayUserAnswer();
  }

  generateUuid() {
    let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case "x":
          chars[i] = Math.floor(Math.random() * 16).toString(16);
          break;
        case "y":
          chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
          break;
      }
    }
    return chars.join("");
  }

  isAndroid() {
    var isAndroid = false;
    if (navigator.userAgent.match(/Android/i) == "Android") {
      isAndroid = true;
    }
    return isAndroid;
  }

  isIphone() {
    if (navigator.userAgent.match(/iPhone/i) == "iPhone") {
      return true;
    }
    return false;
  }
}
